import { useAppSelector } from '../../../redux';
import endSvg from '../../../utils/svgDefinitions/endSvg';
import handleSvg from '../../../utils/svgDefinitions/handleSvg';
import startEndSvg from '../../../utils/svgDefinitions/startEndSvg';
import startSvg from '../../../utils/svgDefinitions/startSvg';
import useSvgImages, { SvgDefinition } from '../../../utils/useSvgImages';
import ActivePolyline from './ActivePolyline';
import CutSnapshotPolyline from './CutSnapshotPolyline';
import HoveredPolyline from './HoveredPolyline';
import InactivePolylines from './InactivePolylines';
import Markers from './Markers';
import SavedRoutePolyline from './SavedRoutePolyline';

export const svgDefinitions: SvgDefinition[] = [startSvg, endSvg, startEndSvg, handleSvg];

type SegmentsProps = {
  hideDirectionalArrows?: boolean;
};

const Segments = ({ hideDirectionalArrows }: SegmentsProps) => {
  const { segments, isEditing, isInCutMode } = useAppSelector(state => ({
    segments: state.customRoute.route.segments,
    isEditing: state.customRoute.isEditing,
    isInCutMode: state.customRoute.cutData !== undefined
  }));

  // Load images that will be used in Segment components so that the components don't all load the same images
  const { imagesAreLoaded } = useSvgImages(svgDefinitions);

  if (!segments || !imagesAreLoaded) {
    return null;
  }

  return (
    <>
      {isInCutMode && <CutSnapshotPolyline hideArrows={hideDirectionalArrows} />}
      {isEditing && <SavedRoutePolyline />}
      <InactivePolylines hideArrows={hideDirectionalArrows} />
      <ActivePolyline hideArrows={hideDirectionalArrows} />
      {!isEditing && <HoveredPolyline />}
      <Markers />
    </>
  );
};

export default Segments;
